import { createApiHook } from '../hooks';
import { aiGenerationApiFactory } from './aiGenerationApiFactory';

export const useAiGenerationApi = createApiHook(aiGenerationApiFactory);
